import { render, staticRenderFns } from "./StatsSellersRow.vue?vue&type=template&id=081ad49f&"
import script from "./StatsSellersRow.vue?vue&type=script&lang=js&"
export * from "./StatsSellersRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports